let intervalId;

const stop = () => {
  if (intervalId !== undefined) {
    window.clearInterval(intervalId);
    intervalId = undefined;
  }
};

const isTimerStarted = () => intervalId != null;

const start = (expiresAt, onExpirationTresholdReached) => {
  if (intervalId !== undefined) {
    stop();
  }

  intervalId = window.setInterval(() => {
    if (Date.now() >= expiresAt) {
      stop();
      onExpirationTresholdReached();
    }
  }, 1000);
};

export default {
  isTimerStarted,
  start,
};
